// @ts-nocheck
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import XHR from 'i18next-xhr-backend';

const i18nInstance = i18n
    .use(initReactI18next)
    .use(LanguageDetector)
    .use(XHR);

function configureI18n() {
  i18nInstance
    .init({
      debug: process.env.NODE_ENV === 'development',
      supportedLngs: ['en', 'da'],
      fallbackLng: 'en',
      detection: {
        order: ['localStorage', 'navigator'],
        lookupLocalStorage: 'i18nextLng',
      },
      backend: {
        loadPath: '/locales/{{lng}}/{{ns}}.json',
      },
    });
  return i18nInstance;
}

export { i18nInstance, configureI18n };
